import _ from "lodash";
import { TypeDefinition } from "../generic";

export class InvitationResponse {
    public static NoResponse: TypeDefinition = { id: 0, name: "No response" };
    public static Declined: TypeDefinition = { id: -1, name: "Declined" };
    public static Accepted: TypeDefinition = { id: 1, name: "Accepted" };

    public static Values: TypeDefinition[] = [
        InvitationResponse.NoResponse,
        InvitationResponse.Declined,
        InvitationResponse.Accepted,
    ];

    public static IDs: number[] = InvitationResponse.Values.map((v) => v.id);

    public static getResponse = (x: number | { invitationResponseId: number | null }) => {
        const s = typeof x === "number" ? x : x.invitationResponseId;
        return _.find(InvitationResponse.Values, (v) => v.id === s);
    }

    public static isAccepted = (x: number | { invitationResponseId: number | null }) => {
        const s = typeof x === "number" ? x : x.invitationResponseId;
        return s === InvitationResponse.Accepted.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/abstract/InvitationResponse.ts